import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const useZpaxRedirect = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const zpaxParam = searchParams.get("zpax");

    if (zpaxParam === "1") {
      // Determine the correct app file based on hostname
      let appfor = "app.html";
      switch (window.location.hostname) {
        case "cip.circadia.link":
          appfor = "production.html";
          break;
        case "cipstaging.circadia.link":
        case "cip-beta.circadia.link":
        case "cipbeta.circadia.link":
          appfor = "staging.html";
          break;
        case "cipdev.circadia.link":
          appfor = "dev.html";
          break;
        case "vitals.circadia.link":
          appfor = "vitals.html";
          break;
        case "localhost":
          appfor = "localhost.html";
          break;
        default:
          appfor = "app.html";
          break;
      }

      // Redirect to Z-Pax OAuth
      const zpaxAuthUrl = `https://sapi.auth.myzpax.com/connect/authorize?client_id=circadiahealth-7a64842c92434018a3e312f82feff6c1&response_type=code&redirect_uri=https://zpax-sso.circadia.link/${appfor}&scope=profile`;

      window.location.href = zpaxAuthUrl;
    }
  }, [searchParams]);

  return {
    isZpax: searchParams.get("zpax") === "1",
  };
};
